import * as c from "./constants";

export const setCartID = (id) => ({
  type: c.SET_CART_ID,
  payload: id,
});

export const doReset = () => ({
  type: c.RESET_CART,
});

export const setAddCardError = (error) => ({
  type: c.SET_ADD_CARD_ERROR,
  payload: error,
});

export const setCartCards = (cards) => ({
  type: c.SET_CART_CARDS,
  payload: cards,
});

export const setUpdateCardError = (error) => ({
  type: c.SET_UPDATE_CARD_ERROR,
  payload: error,
});

export const setLoadingState = (idx, state) => ({
  type: c.SET_LOADING_STATE,
  payload: { id: idx, state },
});
